module.exports = __webpack_public_path__ + "static/media/logo.6de14045.png";